function updateSingle(nextSlide) {

    // Update colors
    const newCurrent = document.querySelectorAll('.slick-slide')[nextSlide].querySelector('a');
    const slide = {
        id: newCurrent.getAttribute('data-id'),
        postid: newCurrent.getAttribute('data-postid'),
        bgcolor: newCurrent.getAttribute('data-bgcolor'),
        year: newCurrent.getAttribute('data-year'),
        lang: newCurrent.getAttribute('data-lang'),
        url: newCurrent.getAttribute('data-href')
    };

    updateBodyColor(newCurrent.getAttribute('data-bgcolor'));

    // Update postID reference
    document.querySelector('article').setAttribute('id', 'post-' + slide.postid);

    // Update contents
    run(slide.id, slide.postid, slide.year, slide.lang);

    // Update URL
    let pageUrl = slide.url;

    if (typeof (history.pushState) != "undefined") {
        const state = { post_id: slide.postid, page_url: slide.url };

        history.pushState(state, "", slide.url);
    }
}



function run(id, post_id, year, lang) {

    let xhr   = new XMLHttpRequest();
    var url   = mswpt_vars.ajax_url;
    var nonce = document.getElementById('single-artwork-nonce');

    xhr.open('GET', url + '?action=get_flat_post&id=' + id + '&post_id=' + post_id + '&year=' + year + '&lang=' + lang + '&nonce=' + nonce.value, true);
    xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            const data = JSON.parse(this.responseText).data;

            document.getElementById('dropdown').innerHTML = data.dropdown;
            document.getElementById('dropdown').classList.remove('--loading');

            // re-bind event listeners
            document.querySelectorAll('.dropdown').forEach((elem, idx) => {
                elem.addEventListener('mouseleave', function (evt) {
                    evt.target.closest('.dropdown').classList.remove('--open');
                });
            });

            document.getElementById('sketches').innerHTML = data.sketches;
            document.getElementById('sketches').classList.remove('--loading');

            document.getElementById('main-content').innerHTML = data.main_content;
            document.getElementById('main-content').classList.remove('--loading');

            document.getElementById('pagination').innerHTML = data.pagination;
            document.getElementById('pagination').classList.remove('--loading');

            var languageSwitchers = [...document.querySelectorAll('.language-switcher ul')]

            languageSwitchers.forEach((switcher) => {
                switcher.innerHTML = data.languages;
            });

            var headLinks = [...document.querySelectorAll('link[rel="alternate"]')];
            var caninicalLink = document.querySelector('link[rel="canonical"]');

            headLinks.forEach((item) => {
                let lang = item.attributes.hreflang.value;

                item.attributes.href.value = data.head.alternate[lang].url;
            });

            if (document.querySelector('link[rel="canonical"]') != null)
                document.querySelector('link[rel="canonical"]').attributes.href.value = data.head.canonical.url;

            initSketchesLightbox();

            document.body.classList.remove('--slide-clicked');
        }
    }
    xhr.send();

}


function initSketchesLightbox() {

    // ------------------ Sketches lightbox - Init
    lightGallery(document.getElementById('lightgallery'), {
        plugins: [lgThumbnail],
        licenseKey: '92BBD428-2B6D-4B32-8B52-20E58C6764AD',
        speed: 500,
        hideScrollbar: true,
        height: '300px',
        counter: false,
        download: false,
        controls: false,
        showCloseIcon: false,
        alignThumbnails: 'middle',
        thumbHeight: 'auto',
        thumbWidth: 80,
    });
}





document.addEventListener('DOMContentLoaded', function() {

    if (document.body.classList.contains('single-artwork')) {

        // ------------------ Artwork carousel - Init
        const currentNodeId = document.querySelector('article').getAttribute('id').split('-')[1];
        let currentSlide = document.querySelector('#slider li a[data-postid="' + currentNodeId + '"]');

        document.body.setAttribute('style', 'background-color: ' + currentSlide.getAttribute('data-bgcolor'));

        const slides = document.querySelectorAll('#slider a');


        if ((tabletLandscape.matches || desktopScreen.matches)) {

            jQuery('#slider').slick({
                centerMode: true,
                centerPadding: '10%',
                slidesToShow: 1,
                lazyLoad: 'progressive',
                arrows: false,
                dots: false,
                infinite: false,
                variableWidth: true
            });
        //}
        /*
        else {
            // Mobile version
            jQuery('#slider').slick({
                centerMode: false,
                slidesToShow: 1,
                lazyLoad: 'progressive',
                arrows: false,
                dots: false,
                infinite: false,
                variableWidth: false,
                adaptiveHeight: true
            });
        }
        */

            let slideArray = Array.from(slides);
            let targetSlide = slideArray.indexOf(currentSlide);

            jQuery('#slider').slick('slickGoTo', targetSlide);
        }

        // ------------------ Artwork carousel - beforeChange
        jQuery('#slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
            jQuery('.prev-slide').removeClass('prev-slide');
            jQuery('.next-slide').removeClass('next-slide');

            document.body.querySelectorAll('main section').forEach((e) => { e.classList.add('--loading'); });

            updateSingle(nextSlide);

            checkPageColors();
        });

        // ------------------ Artwork carousel - afterChange
        jQuery('#slider').on('afterChange', function(event, slick, currentSlide, nextSlide){

            let prev =  jQuery('.slick-current').prev();
            let next = jQuery('.slick-current').next();

            if (prev.length != 0){
                prev.addClass('prev-slide');
            }

            if (next.length != 0) {
                next.addClass('next-slide');
            }


            // Update current title and artist
            jQuery('#artwork-title').text(jQuery('.slick-current img').attr('alt'));
            jQuery('#artist-name').text(jQuery('.slick-current a').attr('data-artist'));
            document.getElementById('title').classList.remove('--loading');

            // Update HTML page title
            //document.title = document.title.split(' - ')[0] + ' - ' + jQuery('.slick-current img').attr('alt');

            let tagTitle = jQuery('.slick-current a').attr('data-tagtitle');

            document.title = tagTitle;
            document.querySelector('[property="og:title"]').setAttribute('content', tagTitle);

            // Update hidden lighbox
            jQuery('#lightbox-artwork').attr('src', jQuery('.slick-current a').attr('data-src'));
            jQuery('#lightbox-title').text(jQuery('.slick-current img').attr('alt'));

            initSketchesLightbox();

            // Initial page load (no ajax update)
            if (!document.body.classList.contains('--slide-clicked'))
                document.body.querySelectorAll('main section:not(#title)').forEach((e) => { e.classList.remove('--loading'); });

        });

        // ------------------ Bottom carousel pagination handlers
        /*
        let pagPrev = jQuery('#pagination ul li:first-child a');
        let pagNext = jQuery('#pagination ul li:last-child a');

        pagPrev.on('click', function(){
            window.scrollTo(0,0);
            setTimeout(function(){ jQuery('#slider').slick('slickPrev'); }, 700);
        });

        pagNext.on('click', function(){
            window.scrollTo(0,0);
            setTimeout(function(){ jQuery('#slider').slick('slickNext'); }, 700);
        });
        */

    }
});


// ------------------ Slides click handlers (only for desktops)
if ((tabletLandscape.matches || desktopScreen.matches)) {

    document.addEventListener('click', function(e) {

        // Carousel slides
        if (e.target.closest('.slick-slide')) {

            e.preventDefault();
            document.body.classList.add('--slide-clicked');

            let slide = e.target.closest('.slick-slide');

            if (slide.classList.contains('slick-current')) {
                document.getElementById('custom-backdrop').classList.add('in');
                document.body.classList.add('lg-overlay-open');
            }
            else if (slide.classList.contains('prev-slide')) {
                jQuery('#slider').slick('slickPrev');
            }
            else if (slide.classList.contains('next-slide')) {
                jQuery('#slider').slick('slickNext');
            }
        }
        else if (e.target.closest('#custom-backdrop')) {
            e.preventDefault();
            document.getElementById('custom-backdrop').classList.remove('in');
            document.body.classList.remove('lg-overlay-open');
        }

    });

}
